var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartagerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_6285",
    "data-name": "Groupe 6285",
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.795,
    height: 47.796,
    viewBox: "0 0 47.795 47.796",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5580",
    "data-name": "Trac\\xE9 5580",
    d: "M181.4,93.8h11.2a1.4,1.4,0,1,0,0-2.8H181.4a1.4,1.4,0,0,0,0,2.8",
    transform: "translate(-163.197 -82.505)",
    fill: "#202b53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5581",
    "data-name": "Trac\\xE9 5581",
    d: "M181.4,153.8h11.2a1.4,1.4,0,1,0,0-2.8H181.4a1.4,1.4,0,0,0,0,2.8",
    transform: "translate(-163.197 -136.904)",
    fill: "#202b53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5582",
    "data-name": "Trac\\xE9 5582",
    d: "M61.4,213.8H83.8a1.4,1.4,0,0,0,0-2.8H61.4a1.4,1.4,0,0,0,0,2.8",
    transform: "translate(-54.399 -191.303)",
    fill: "#202b53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5583",
    "data-name": "Trac\\xE9 5583",
    d: "M61.4,273.8H78.728a1.4,1.4,0,0,0,0-2.8H61.4a1.4,1.4,0,0,0,0,2.8",
    transform: "translate(-54.399 -245.702)",
    fill: "#202b53"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5584",
    "data-name": "Trac\\xE9 5584",
    d: "M36.5,25.3V4.2A4.277,4.277,0,0,0,32.205,0H12.6a1.414,1.414,0,0,0-.994.414L.406,11.71A1.413,1.413,0,0,0,0,12.7v30.9a4.206,4.206,0,0,0,4.2,4.2H36.5a11.249,11.249,0,1,0,0-22.5M11.2,4.8V11.3H4.761ZM4.2,45a1.4,1.4,0,0,1-1.4-1.4V14.1h9.8A1.4,1.4,0,0,0,14,12.7V2.8h18.2A1.487,1.487,0,0,1,33.7,4.2V25.647A11.329,11.329,0,0,0,26.721,30.9H7a1.4,1.4,0,0,0,0,2.8h18.56a11.1,11.1,0,0,0-.357,2.8H7a1.4,1.4,0,0,0,0,2.8H25.559A11.343,11.343,0,0,0,29.1,45Zm32.3,0A8.609,8.609,0,0,1,28,36.5a8.5,8.5,0,0,1,16.99,0A8.609,8.609,0,0,1,36.5,45",
    transform: "translate(0 0)",
    fill: "#202b53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5585",
    "data-name": "Trac\\xE9 5585",
    d: "M339.007,361.4l-4.72,4.643-1.912-1.851a1.4,1.4,0,0,0-1.948,2.013l2.894,2.8a1.4,1.4,0,0,0,1.956-.008l5.694-5.6a1.4,1.4,0,0,0-1.964-2",
    transform: "translate(-299.195 -327.301)",
    fill: "#202b53"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartagerIcon);
export default __webpack_public_path__ + "static/media/partager-icon.b0e9294e44fbcdbb52e2d17c8c68bebd.svg";
export { ForwardRef as ReactComponent };